module.exports = __webpack_public_path__ + "img/right_map.18331d07.png";